import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import Overview from "../pages/Overview.vue";

export default new Route("exports", "/exports", RouterView, [
	new Route("exports.index", "", Overview, []),
	new Route("exports.view", ":uuid", Overview, []),
]);
